/**
 * This module has the hook, declaration types and tests for the acceptCheckoutRule mutation
 * {@label ACCEPT_CHECKOUT_RULE}
 */
import acceptCheckoutRule from './hook'

export * as mutation from './mutation'
export * as types from './types'
export default acceptCheckoutRule
